interface Math {
	clamp(input: number, min: number, max: number): number;
}

/**
 * @description Adds a clamp function to the Math object. Will cut values which are below of the min input and above the max inputs.
 * @param input The numeric value which should be clamped.
 * @param min The numeric value which defines the minimum value after which the input value will be clamped to.
 * @param max The numeric value which defines the maximum value after which the input value will be clamped to.
 * @returns {number} The input number value if not clamped. If input < min, return will be min, if input > max, return will be max.
 */
Math.clamp = function(input, min, max) {
	return Math.min(Math.max(input, min), max);
};
